export default "__VITE_ASSET__CARJTeAn__"